import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class IdInversorService {

  private investorId: string | null = null;

  constructor() {}

  setIdInversor(id: string) {
    this.investorId = id;
  }

  getIdInversor(): string | null {
    return this.investorId;
  }

  
}
